import React, { useState, useEffect, useContext } from 'react';
import { Button, Input, Label } from 'semantic-ui-react';
import queryString from 'query-string';
import { linkAlexa } from '../../../services/sso';
import RedirectContext from '../../../contexts/RedirectContext';
import UserContext from '../../../contexts/UserContext';
import { toast } from 'react-toastify';

import './style.less';
import { getMyQuota } from '../../../services/quotas';

const SSOAlexaUser = (props) => {
    const { userObject, setUser, reloadRegistrantLists } = useContext(UserContext);
    const [firstName, setFirstName] = useState();
    const [lastName, setLastName] = useState();
    const toggleRedirect = useContext(RedirectContext);

    const linkAlexaUser = async (code, user) => {
        const hostname = window.location.hostname;
        const redirect_uri = `https://${hostname}/sso-redirect`;

        const response = await linkAlexa(code, user, redirect_uri);
        console.log(response, 'response');

        const noCC = response && response.response && response.response.noCC;
        console.log('nocc', noCC);
        await reloadRegistrantLists();

        toast.success(
            user.firstName
                ? `Account linked with Alexa successfully for ${user.firstName}`
                : 'Alexa Linked Successfully!',
            {
                position: 'bottom-center',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
            },
        );
        if (user.residentId) {
            toggleRedirect(`/message-recipients/${user.residentId}`);
            return;
        } else if (response.paymentManagerId) {
            // getMyQuota
            // If the count matches then redirect,
            const paymentManagerId = response.paymentManagerId;
            const quota = await getMyQuota(paymentManagerId);

            if (quota.totalQuota >= quota.residentCount) {
                // return handleDone(user.invitationToken);
                if (noCC === 'yes') {
                    toggleRedirect(`/activities`);
                } else {
                    toggleRedirect(`/public/checkout-success`);
                }
            } else {
                toggleRedirect(`/public/checkout/${response.paymentManagerId}`);
            }
        }

        // window.location.href = 'https://auto-login-speak2family.surge.sh/news';
        // return props.history.push;
    };

    useEffect(() => {
        const { code, state } = queryString.parse(props.location.search);

        const user = JSON.parse(localStorage.getItem(atob(state)));
        if (user.isAlexaUserInvite) {
            toggleRedirect(`/alexa-invite-sso-redirect${props.location.search}`);
        } else {
            setFirstName(user.firstName);

            const hostname = window.location.hostname;
            const redirect_uri = `https://${hostname}/sso-redirect`;

            linkAlexaUser(code, user, redirect_uri);
        }
        // const [type, f] = user.split(':');
    }, [props.location.search, toggleRedirect]);

    return (
        <div className="sso-container">
            <div className="loading">
                {firstName && lastName ? `Enabling Alexa For ${firstName} ${lastName}` : 'Loading...'}
            </div>
        </div>
    );
};

export default SSOAlexaUser;
